import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { Separator } from '@radix-ui/react-select';
import { useEffect } from 'react'

function About() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
<div className="flex items-center justify-center min-h-screen">
      <div className="text-center max-w-prose px-16">
              {/* Center: SVG Logo */}
      <div className="flex items-center justify-center overflow-visible my-8">
        <Link to="/">
          <img
            src="/assets/logos/Antoia_Wordmark.svg"
            alt="Museum Circle Logo"
            className="h-12 md:h-16"
          />
        </Link>
      </div>

        {/* Intro copy */}
        {/* <p className="text-lg font-sans font-regular text-black">
          Antoia – House of data couture, is a designer
          brand focused on manifesting personal meaning into fashion,
          accessories and interiors. Currently we are rebranding our platform to further improve your brand experience – and will be back in 08.2025.
<br></br><br></br>
          For all enquiries: hello@cypherloom.com

        </p> */}

      </div>
    </div>
  );
}

export default About;